export type GiscusPublicConfig = {
  repo: `${string}/${string}`;
  repoId: string;
  category: string;
  categoryId: string;
};

export function readGiscusConfig(): GiscusPublicConfig | null {
  const repo = import.meta.env.VITE_GISCUS_REPO;
  const repoId = import.meta.env.VITE_GISCUS_REPO_ID;
  const category = import.meta.env.VITE_GISCUS_CATEGORY ?? 'Blog Comments';
  const categoryId = import.meta.env.VITE_GISCUS_CATEGORY_ID;

  if (!repo || !repoId || !categoryId) {
    return null;
  }

  return {
    repo: repo as `${string}/${string}`,
    repoId,
    category,
    categoryId,
  };
}

export function isGiscusConfigured(): boolean {
  return readGiscusConfig() !== null;
}

const GISCUS_SCRIPT_SRC = 'https://giscus.app/client.js';

export function mountGiscus(
  container: HTMLElement,
  config: GiscusPublicConfig
): () => void {
  container.replaceChildren();

  const script = document.createElement('script');
  script.src = GISCUS_SCRIPT_SRC;
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.setAttribute('data-repo', config.repo);
  script.setAttribute('data-repo-id', config.repoId);
  script.setAttribute('data-category', config.category);
  script.setAttribute('data-category-id', config.categoryId);
  script.setAttribute('data-mapping', 'pathname');
  script.setAttribute('data-strict', '0');
  script.setAttribute('data-reactions-enabled', '1');
  script.setAttribute('data-emit-metadata', '0');
  script.setAttribute('data-input-position', 'bottom');
  script.setAttribute('data-theme', 'light');
  script.setAttribute('data-lang', 'en');
  script.setAttribute('data-loading', 'lazy');

  container.append(script);

  return () => {
    container.replaceChildren();
  };
}
